import React from 'react';
import { Box } from 'vindi-ds-components';
import styles from './styles';

function Headline({ children }) {
  return (
    <Box css={styles.headline}>
      {children}
    </Box>
  );
}

export default Headline;
